<ziro-fieldset-header [legend]="'tkey;admin.site_management.bulk_change.select_field'">
  <ziro-select fieldId="siteName"></ziro-select>
  <ziro-select fieldId="serviceName"></ziro-select>
  <ziro-select fieldId="fieldName"></ziro-select>
</ziro-fieldset-header>
@if (entity && entity.fieldName) {
  <div>
    <legend>{{ 'tkey;admin.site_management.bulk_change.field.preview' | translate }}</legend>
    <table class="table table-striped table-condensed" data-automation="preview-table">
      <tbody>
        @for (fieldData of selectedFieldData | keyvalue: originalOrder; track fieldData) {
          <tr class="group-row">
            <td scope="row" data-automation="preview-table-field" class="w-25">
              <strong>{{ fieldData.key }}</strong>
            </td>
            <td data-automation="preview-table-value">{{ fieldData.value }}</td>
          </tr>
        }
      </tbody>
    </table>
  </div>
}
<div [hidden]="!(selectedFieldData && entity && entity.fieldName)">
  <div class="row ms-0 me-1 border-bottom">
    <div class="d-inline ps-0 pe-1 w-auto">
      <h4>
        {{ 'tkey;admin.site_management.bulk_change.copy.field.settings.header.label' | translate }}
      </h4>
    </div>
    <hr />
  </div>

  <div class="row">
    <div class="col-sm-12">
      <ziro-radio [fieldId]="'copyDestination'"></ziro-radio>
    </div>
  </div>

  <ziro-select [fieldId]="'selectedSites'"></ziro-select>
</div>
